<template>
  <div class="login">
    <h1>Generate Your Tesla Token!</h1>
    <p>
      Simply use your tesla login to generate an OAuth token that can be safely used with a multitude
      of apps and programs to manage your tesla.
    </p>
    <vk-card>
      <div class="uk-margin" v-vk-margin>
        <input type="email" v-model="email" v-on:keyup.enter="signIn" placeholder="Email" class="uk-input"><br>
        <input type="password" v-model="password" v-on:keyup.enter="signIn" placeholder="Password" class="uk-input"><br>
        <div class="uk-alert-danger uk-width-1-2@m uk-margin-auto uk-padding-small uk-margin-bottom" v-if="loginerr">
          {{ loginerr }}
        </div>
      <vk-button type="primary" v-on:click="signIn">Generate Token Now!</vk-button>
      </div>
      <div class="uk-width-1-2@m uk-margin-auto uk-padding-small uk-margin-bottom"  v-if="token">
          <p class="uk-text-success">Your tesla token is:<span class="uk-text-break">{{ token }}</span></p>
      </div>
    </vk-card>
    <p>
      Only your device and Tesla's servers will talk to each other; no nasty middleman. This is the safest method in 
      generating your key. This project is open source and you can see the full source code <a href="https://github.com">HERE</a>.
    </p>
    <p>If you'd like to donate some supercharging to the creator of this app feel free to do so here:</p>
  </div>
</template>


<script>
import tesla from 'teslajs';

export default {
  name: 'HelloWorld',
  data() {
    return {
      email: '',
      password: '',
      loginerr: '',
      token: '',
    };
  },
  methods: {
    signIn() {
      tesla.login(this.email, this.password, (err, result) => {
        if (result.error) {
          this.loginerr = result.error;
        }
        if (result.authToken) {
          console.log('Token Generation was Succesful!');
          console.log(token);
          this.token = result.authToken;
        }
      });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue